/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './disableAccountInvites.defs'
export { main as default } from './disableAccountInvites.defs'
